import {
  SupportDashboardDetailMetric,
  SupportTicketFilterOption,
  SupportTicketTableHeader,
} from "./support-dashboard-detail.types";

export const SUPPORT_DASHBOARD_DETAIL_TABLE_HEADERS: SupportTicketTableHeader[] =
  [
    { id: "ticket_id", name: "Issue Key" },
    { id: "ticket_summary", name: "Summary" },
    { id: "priority", name: "Priority" },
    { id: "status", name: "Status" },
    { id: "created_on", name: "Created On" },
    { id: "reporter", name: "Reporter" },
    { id: "closed_on", name: "Closed On" },
  ];

export const SUPPORT_DASHBOARD_DETAIL_CREATION_TIME_TABLE_HEADERS: SupportTicketTableHeader[] =
  [
    { id: "ticket_id", name: "Issue Key" },
    { id: "ticket_summary", name: "Summary" },
    { id: "issue_type", name: "Issue Type" },
    { id: "priority", name: "Priority" },
    { id: "status", name: "Status" },
    { id: "created_on", name: "Created On" },
    { id: "updated_on", name: "Updated On" },
    { id: "assignee", name: "Assignee" },
    { id: "reporter", name: "Reporter" },
    { id: "organisation", name: "Organisation" },
  ];

export const SUPPORT_DASHBOARD_DETAIL_FILTER_KEYS: SupportTicketFilterOption[] =
  [
    { id: "summary", name: "Ticket Summary" },
    { id: "issuekey", name: "Ticket Id" },
    { id: "priority", name: "Priority" },
  ];

export const SUPPORT_DASHBOARD_DETAIL_METRIC_TITLES: Record<
  SupportDashboardDetailMetric,
  string
> = {
  "total-tickets": "Total Tickets",
  "resolution-met": "Resolution SLA - Met",
  "resolution-breached": "Resolution SLA - Breached",
  "response-met": "Response SLA - Met",
  "response-breached": "Response SLA - Breached",
  "business-hours": "Tickets by Creation Time - Business Hours",
  "after-hours": "Tickets by Creation Time - After Hours",
  "priority-details": "Tickets by Priority",
  "sla-priority-details": "SLA Priority Details",
};
